import { ItemWithIdentifier } from "../types";

/**
 * Get a unique identifier for an item
 */
export function getItemIdentifier(item: ItemWithIdentifier): string {
  if (item.uuid) return item.uuid;
  if (item.id) return String(item.id);

  // Fallback to JSON stringification if no standard identifier
  console.warn("Item does not have a standard identifier (uuid or id):", item);
  return JSON.stringify(item);
}

/**
 * Check if an item is selected
 */
export function isItemSelected(item: ItemWithIdentifier, selection: string[]): boolean {
  const identifier = getItemIdentifier(item);
  return selection.includes(identifier);
}

/**
 * Toggle item selection
 */
export function toggleItemSelection(
  item: ItemWithIdentifier,
  selection: string[],
  multiSelection: boolean = true,
): string[] {
  const identifier = getItemIdentifier(item);
  const isSelected = selection.includes(identifier);

  if (isSelected) {
    return selection.filter((id) => id !== identifier);
  } else {
    if (multiSelection) {
      return [...selection, identifier];
    } else {
      return [identifier];
    }
  }
}

/**
 * Select all items
 */
export function selectAllItems(items: ItemWithIdentifier[]): string[] {
  return items.map((item) => getItemIdentifier(item));
}

/**
 * Clear all selections
 */
export function clearSelection(): string[] {
  return [];
}
